import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl } from '@angular/forms';
import { CandidatoAprovadoService } from '../../../services/candidato-aprovado.service';
import { MotivoCandidatoReprovadoService } from '../../../services/motivo-candidato-reprovado.service';
import { CandidatoReprovadoService } from '../../../services/candidato-reprovado.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { Observable } from 'rxjs/Observable';
import { CandidatoService } from '../../candidato/candidato.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { AuthService } from '../../admin/auth.service';

@Component({
  templateUrl: './analisar-documentacao.component.html'
})

export class AnalisarDocumentacaoComponent extends WebPage implements OnInit {

  motivos: any[] = [];
  candidato;

  idCandidato;
  uploadUrl;
  tipoArquivo;
  nomeDocumento;
  form: FormGroup;
  formReprovado: FormGroup;
  formDesclassificado: FormGroup;
  candidatoAprovado;
  analiseDocumental;
  observacao;
  arquivosToRemove = new FormArray([]);
  resultado;
  motivosReprovado;

  // get arquivos() { return this.form.get('arquivos') as FormArray; }

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private candidatoService: CandidatoService,
    private candidatoAprovadoService: CandidatoAprovadoService,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private route: ActivatedRoute, private router: Router,
    private motivoReprovado: MotivoCandidatoReprovadoService,
    private candidatoReprovado: CandidatoReprovadoService,
    private arquivoService: ArquivoService
  ) {
      super(messageService);

      this.route.paramMap.subscribe(params =>
        this.idCandidato = params.get('idCandidato')
      );
    }

  ngOnInit() {
    this.formDesclassificado = this.fb.group({
      idCandidato: [this.idCandidato],
      justificativa: ['', Validators.required]
    });

    console.log(this.formDesclassificado.value)

    Observable.combineLatest(
      this.candidatoService.getFull(this.idCandidato),
      this.candidatoAprovadoService.getFull(this.idCandidato),
      this.motivoReprovado.getFull(),
      this.candidatoService.getAnaliseDocumental(this.idCandidato)
    )
    .finally(() => this.isLoading = false)
    .subscribe(
      combined => {
        this.candidato = combined[0];

        this.candidatoAprovado = combined[1];
        if (this.candidatoAprovado !== null && this.candidatoAprovado.length > 0) {
          this.resultado = 'aprovado';
          this.candidatoAprovado.forEach(e => {
            this.adicionaArquivo(e.arquivo.idArquivo, e.arquivo.nome, false, e.arquivo.tipoArquivo.descricao);
          });
        }

        this.motivosReprovado = combined[2];

        this.analiseDocumental = combined[3];

        if (this.analiseDocumental !== null && this.analiseDocumental.resultadoAnalise === "1") {
          this.resultado = 'aprovado';
          this.form = this.fb.group({
            idTipoDocumento: [null, Validators.required],
            arquivos: new FormArray([])
          });
        } else if (this.analiseDocumental !== null && this.analiseDocumental.resultadoAnalise === "0") {
          this.resultado = 'reprovado';
          this.observacao = this.analiseDocumental.observacao;
          this.formReprovado = this.fb.group({
            idMotivoCandidatoReprovado: [`16b283dc-82d9-4fac-8894-c9e336a69f3f`, Validators.required],
            observacao: [`Documentação não aprovada por inconformidade - SIGOP`, Validators.required]
          });
        } else {
          this.formDesclassificado = this.fb.group({
            justificativa: ['', Validators.required]
          });
        }
      },
      error => this.gerenciaErro(error)
    );
  }

  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean, nomeDocumento = '') {
    console.log(idArquivo);
    if (idArquivo !== '') {
      this.isLoading = false;
      const arquivoFormGroup = this.fb.group({
        idArquivo: idArquivo,
        nomeArquivo: nomeArquivo,
        nomeDocumento: nomeDocumento === '' ? this.nomeDocumento : nomeDocumento,
        isOld: isOld
      });
      // this.arquivos.push(arquivoFormGroup);
    }
  }

  downloadArquivoDocumentacao(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'documentos');
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);
    // const index = this.arquivos.controls.indexOf(arquivo);
    // this.arquivos.removeAt(index);
    const arquivos: AbstractControl[] = [];
    arquivos.push(arquivo);
    this.removeArquivosDoBanco(arquivos);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    arquivos.forEach(arquivo =>
      this.candidatoAprovadoService.removeCandidatoAprovado(arquivo.value.idArquivo)
        .subscribe(() => {
          this.arquivoService.removeArquivo(arquivo.value.idArquivo)
            .subscribe(() => {});
        })
    );
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.isLoading = false;
  }

  gerarTermo() {
    this.isLoading = true;
    this.candidatoAprovadoService.gerarTermo(this.idCandidato)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          if (data !== null && data !== '') {
            this.messageService.add({ severity: 'error', summary: 'Atenção', detail: data.toString() });
            return;
          }

          this.candidatoService.downloadTermoAprovado(this.idCandidato);

          setTimeout(
            () => this.router.navigate(['/gerenciar-etapas']),
            2000
          );
        },
        error => this.gerenciaErro(error)
    );
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        // let arquivos: AbstractControl[];
        // arquivos = this.arquivos.controls;
        // this.removeArquivosDoBanco(this.arquivos.controls);
        this.router.navigate(['/gerenciar-etapas']);
      }
    });
  }

  desclassificar() {
    this.formDesclassificado = this.fb.group({
      idCandidato: [this.idCandidato],
      justificativa: [this.formDesclassificado.value.justificativa, Validators.required]
    });

    // console.log(this.formDesclassificado.value);

    this.confirmationService.confirm({
      message: 'Deseja realmente desclassificar o(a) candidato(a)?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        console.log(this.idCandidato);
        this.candidatoService.desclassificarCandidatoDocumentacao(this.formDesclassificado.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            () => {
              this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Participante atualizado com sucesso.' });
              setTimeout(
                () => this.router.navigate(['/gerenciar-etapas']),
                2000);
            },
            error => this.gerenciaErro(error)
          );
      }
    });
  }

  incluirMotivoReprovacao(candidatoReprovado) {
    if (candidatoReprovado.idMotivoCandidatoReprovado === null || candidatoReprovado.observacao === null) {
      return;
    }

    candidatoReprovado.idCandidato = this.idCandidato;
    // this.removeArquivosDoBanco(this.arquivos.controls);

    this.confirmationService.confirm({
      message: 'Deseja confirmar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.candidatoReprovado.motivoReprovacao(candidatoReprovado)
          .finally(() => this.isLoading = false)
          .subscribe(
            () => {
              setTimeout(
                () => this.router.navigate(['/gerenciar-etapas']),
                2000);
            },
            error => this.gerenciaErro(error)
          );
      }
    })
  }

  onSelect(item) {
    switch (item.target.value) {
      case '3AD2F54E-1EC6-45FF-B3FF-1B85D3763DF5':
        this.tipoArquivo =  'documentoIdentificacao';
        this.nomeDocumento = 'CNH - documento de identificação';
        break;
      case 'F53F1A1E-DDBE-406E-B208-DC9D2E4C287E':
        this.tipoArquivo =  'certidaoNadaConstaProntuario';
        this.nomeDocumento = 'Certidão de Nada Consta/Prontuário';
        break;
      case 'DF6908EC-1C21-49B3-9524-11403D6667BA':
        this.tipoArquivo =  'comprovanteResidencia';
        this.nomeDocumento = 'Comprovante de Residência';
        break;
      case '5AC24F1B-4ABE-448B-BAC5-AE09CA2783C0':
        this.tipoArquivo =  'comprovanteVinculo';
        this.nomeDocumento = 'CTPS - comprovante de vínculo';
        break;
      default:
        this.tipoArquivo = '';
        this.nomeDocumento = '';
    }

    this.uploadUrl = this.arquivoService.uploadUrl + this.tipoArquivo + '/' + this.idCandidato;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/etapa/analisar-documentacao/analisar-documentacao.component.ts